// extracted by mini-css-extract-plugin
export var actionIcon = "_rm-0";